module.exports = __webpack_public_path__ + "fonts/iconfont.d039bff8.ttf";